module.exports = __webpack_public_path__ + "img/chart_icon.11551d27.svg";